module.exports = __webpack_public_path__ + "777eecb17249204e84272b04ad50bba6.svg";